/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CarrierVisitStatus = {
    Expected: 'Expected',
    Arrived: 'Arrived',
    InOperation: 'InOperation',
    Departed: 'Departed',
    Completed: 'Completed',
    Closed: 'Closed',
    Cancelled: 'Cancelled',
} as const;

export type CarrierVisitStatus = typeof CarrierVisitStatus[keyof typeof CarrierVisitStatus];



